<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit Unit </h5>
    <form [formGroup]="EditUnit" (submit)="SubmitEditUnit()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Measurement Quantity </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Title</label>
          <input formControlName="Title" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="Type here...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the title.</small>
        </div>
        <div class="form-group col-md-4" >
          <label for="exampleInputEmail1">Preview</label>
          <div style="font-weight: bold;font-size: 30px;" innerHTML="{{get_Form_Title().value}}"></div>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!EditUnit.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button routerLink="/Unit" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>